import './Breadcremb.less';
import { useState } from 'react';

import {
	SyncOutlined,
	CloseOutlined,
	DoubleRightOutlined,
	DoubleLeftOutlined,
	MenuUnfoldOutlined,
	MenuFoldOutlined
} from '@ant-design/icons';
import { connect } from 'react-redux';
import { openView, closeView, reloadView } from '../share/zeusRouter';
import { useHistory } from 'react-router-dom';
function Breadcremb(props) {
	let { menusHistory, currenMenu, addCurrenMenu } = props;
	const history = useHistory();
	const removeMenusHistory = (item) => {
		closeView(item.path);
		if (menusHistory.length === 1) {
			history.push('/');
			addCurrenMenu('');
		}
	};
	const jump = (item) => {
		const { path, name, parentId } = item;
		openView({
			path,
			name,
			parentId
		});
	};
	const reload = (item) => {
		const { path, name, parentId } = item;
		reloadView({
			path,
			name,
			parentId
		});
	};
	const scrollLeft = () => {
		const left = document.querySelector('.Breadcrembul').scrollLeft;
		// left >= 0 && (document.querySelector('.Breadcrembul').scrollLeft = left - 50);
		left >= 0 &&
			document.querySelector('.Breadcrembul').scrollTo({
				left: left - 200,
				behavior: 'smooth'
			});
	};
	const scrollRight = () => {
		const Breadcrembul = document.querySelector('.Breadcrembul');
		const left = Breadcrembul.scrollLeft;
		const scrollWidth = Breadcrembul.scrollWidth;
		const width = Breadcrembul.clientWidth;
		const hasScroll = scrollWidth - width;
		// left < hasScroll && (document.querySelector('.Breadcrembul').scrollLeft = left + 50);
		left < hasScroll &&
			document.querySelector('.Breadcrembul').scrollTo({
				left: left + 200,
				behavior: 'smooth'
			});
	};
	// 鼠标进入  离开
	let [signIndex, setSignIndex] = useState(-1);
	const mouseEnterBreadCremb = (val) => {
		setSignIndex(val);
	};

	const mouseLeaveBreadCremb = (val) => {
		setSignIndex(-1);
	};
	return (
		<div className="Breadcremb" style={{ width: props.collapsed ? ' calc(100vw - 64px)' : 'calc(100vw - 220px)' }}>
			{props.collapsed ? (
				<MenuUnfoldOutlined className="trigger" onClick={props.onCollapse} />
			) : (
				<MenuFoldOutlined className="trigger" onClick={props.onCollapse} />
			)}

			<DoubleLeftOutlined className="doubleLeftOutlined" onClick={scrollLeft} />
			<ul className="Breadcrembul">
				{menusHistory.map((item, i) => {
					return (
						<li
							key={`${item.id} + ${i}`}
							className={currenMenu === item.path ? ' active' : ''}
							onMouseEnter={() => mouseEnterBreadCremb(i)}
							onMouseLeave={() => mouseLeaveBreadCremb(i)}>
							<div className={currenMenu === item.path ? ' active' : 'noActive'}>
								<span
									className={currenMenu === item.path ? 'breadItem active' : 'breadItem'}
									onClick={() => jump(item)}>
									{item.name}
								</span>
								{item.path !== 'reloadView' && item.name !== '正在刷新...' && (
									<span className="opera">
										{currenMenu === item.path && (
											<span className="reload">
												<SyncOutlined onClick={() => reload(item)} />
											</span>
										)}
										&nbsp;
										{(localStorage.getItem('myWorkplat').includes('1276005') ? i !== 0 : i !== -1) &&
										(signIndex === i || currenMenu === item.path) &&
										item.name !== '首页' ? (
											<span className="close">
												<CloseOutlined className="close" onClick={() => removeMenusHistory(item)} />
											</span>
										) : (
											''
										)}
									</span>
								)}
							</div>
						</li>
					);
				})}
			</ul>
			<DoubleRightOutlined className="doubleRightOutlined" onClick={scrollRight} />
		</div>
	);
}
const mapStateToProps = (state) => {
	return {
		menusHistory: state.menusHistory,
		currenMenu: state.currenMenu
	};
};
const mapDispatchToProps = (dispatch) => {
	return {
		addMenusHistory: (info) => dispatch({ type: 'ADD_MENUSHISTORY', info }),
		addCurrenMenu: (info) => dispatch({ type: 'ADD_CURRENMENU', info })
	};
};
export default connect(mapStateToProps, mapDispatchToProps)(Breadcremb);
